import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import StorefrontIcon from "@mui/icons-material/StorefrontOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";

const sidebarConfig = [
  { labelKey: "dashboard", path: "/delivry-company/dashboard", icon: DashboardIcon },
  { labelKey: "drivers", path: "/delivry-company/drivers", icon: LocalShippingIcon },
  { labelKey: "orders", path: "/delivry-company/orders", icon: ReceiptLongIcon },
  { labelKey: "driverAccess", path: "/delivry-company/driver-access", icon: AdminPanelSettingsOutlinedIcon },
  { labelKey: "storeFees", path: "/delivry-company/store-fees", icon: StorefrontIcon },
  { labelKey: "settings", path: "/delivry-company/settings", icon: SettingsIcon },
];

export default sidebarConfig;
